import UserApp from '@/components/_core/ui/header/user-app-actions';
import LogoApp from '@/components/_core/ui/logo';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name       : 'Header',
  components : {
    UserApp,
    LogoApp
  },
  props: {
    value: {
      type    : Boolean,
      default : false
    },
    showIconMenuExpand: {
      type    : Boolean,
      default : true
    },
    legacyLayout: {
      type    : Boolean,
      default : true
    }
  },
  data() {
    return {
      userAvatar : null,
      opened     : true
    };
  },
  computed: {
    ...mapState({
      sidebarDrawer  : (state) => state._core.application.sidebarDrawer,
      headerHeight   : (state) => state._core.application.headerHeight,
      userName       : (state) => state._core.user.name,
      headerSettings : (state) => state._core.header,
      statusMini     : (state) => state._core.application.statusMini
    }),
    iconmenu() {
      const hamburgerIconMenu = this.opened ? 'mdi-backburger' : 'mdi-forwardburger';
      return this.height === '80' ? hamburgerIconMenu : 'mdi-menu';
    }
  },
  methods: {
    ...mapActions({
      setSidebarDrawer: '_core/application/setSidebarDrawer'
    }),
    ...mapMutations({
      setStatusMini   : '_core/application/SET_STATUS_MINI',
      setHeaderHeight : '_core/application/SET_HEADER_HEIGHT'
    }),
    changeState() {
      if (window.innerWidth < 1250) {
        this.setStatusMini(false);
        this.setSidebarDrawer(!this.sidebarDrawer);
      } else {
        this.setStatusMini(!this.statusMini);
      }
    },
    onResize() {

      if (window.innerWidth < 600) {
        this.setHeaderHeight(64);
      } else {
        this.setHeaderHeight(80);
      }

      if (window.innerWidth < 1250) {
        this.opened = this.sidebarDrawer;
      } else {
        this.opened = !this.statusMini;
      }
    }
  }
};
